import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://jmbnzgnjgjoijujqceti.supabase.co'
const supabaseKey = 'sb_publishable_vlKvUcXk-U1QOfg4c5osvw_WlmC7uGJ'

export const supabase = createClient(supabaseUrl, supabaseKey)

// Who is signed in, read from the session already stored on the device.
// supabase.auth.getUser() makes a network call to Supabase every time (plus a
// browser permission check first), which added about half a second to every
// screen on a phone. The backend verifies the sign-in token on every request
// anyway, so screens only need the user id from here. Same return shape as
// getUser(): { data: { user } }.
export const getLocalUser = async () => {
  try {
    const { data: { session } } = await supabase.auth.getSession()
    return { data: { user: (session && session.user) || null } }
  } catch (e) {
    return { data: { user: null } }
  }
}
